export default __webpack_public_path__ + "static/media/retrospective.4e9a70f5.svg";